// extracted by mini-css-extract-plugin
module.exports = {"support-contact":"support-contact_support-contact__3MzdM","required":"support-contact_required__3ajMZ","btn-blue":"support-contact_btn-blue__1dOEm"};